import './assets/css/global.css'
import './assets/static/tfd'
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
// 兼容IE
import 'babel-polyfill'
/* global spm */
Vue.config.productionTip = false
Vue.use(iView)

router.beforeEach((to, from, next) => {
  var fullPath = to.fullPath
  var nowUrl = spm.sliceBefore(document.URL, '#')
  var spmUrl = spm.addSpm(nowUrl, spm.getPageCode()) + '#' + fullPath
  var toPathName = to.name
  switch (toPathName) {
    case 'homePage':
      spm.push(['_trackPageview', spmUrl])
      next()
      break

    case 'loginsms':
      spm.setPageCode('02005480', '短信登录')
      spm.push(['_trackPageview', spmUrl])
      next()
      break
    case 'loginpwd':
      spm.setPageCode('02005480', '密码登录')
      spm.push(['_trackPageview', spmUrl])
      next()
      break
    case 'register':
      spm.setPageCode('02005479', '密码登录')
      spm.push(['_trackPageview', spmUrl])
      next()
      break
    case 'pcAccount':
      spm.push(['_trackPageview', spmUrl])
      next()
      break
    default:
      next()
  }

  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})

new Vue({
  el: '#root',
  router,
  render: h => h(App)
})
